module.exports = __webpack_public_path__ + "img/company.f2d73e7d.png";